import {space, slash, underscore} from '@convincely/utils/lib/strings.js';

const newLines = /\n\s*/g;
const slashes = /\/\s+/g;

/**
 * @param {string | Array.<string>} str
 * @return {string}
 */
export function stripNewlines(str = '') {
  return Array.isArray(str) ? str.map(stripNewlines) : str.replace(newLines, space);
}

/**
 * @param {string | Array.<string>} str
 * @return {string}
 */
export function cleanSlashes(str = '') {
  return Array.isArray(str) ? str.map(cleanSlashes) : str.replace(slashes, slash);
}

/**
 * @param {string} str
 * @return {string}
 */
export function analyticsString(str = '') {
  return str.split(space).join(underscore);
}

/**
 * @param {string} obj
 * @return {object}
 */
export function sanitizeAnalyticsObject(obj = {}) {
  const sanitized = {};

  for (const key in obj) {
    if (obj[key]) {
      sanitized[key] = analyticsString(obj[key]);
    }
  }

  return sanitized;
}

/**
 * @param {Array} arr
 * @return {Array}
 */
export function cloneDeep(arr) {
  return JSON.parse(JSON.stringify(arr));
}
